import React, { useEffect } from 'react';
const pixelId = '1707630427015805';
const pixelSnippet = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('track', 'PageView');`;

/**
 * Injects the official Meta Pixel base code.
 * Runs when the browser is idle so it never competes with the first paint.
 */
export function MetaPixel() {
  useEffect(() => {
    const inject = () => {
      if (document.getElementById('meta-pixel-code')) return;
      const script = document.createElement('script');
      script.id = 'meta-pixel-code';
      script.text = pixelSnippet;
      document.head.appendChild(script);
    };
    const idle = window.requestIdleCallback;
    if (typeof idle === 'function') {
      const handle = idle(inject, {
        timeout: 2500
      });
      return () => window.cancelIdleCallback?.(handle);
    }
    const timer = window.setTimeout(inject, 1200);
    return () => window.clearTimeout(timer);
  }, []);
  return <noscript data-id="element-84" data-mp="1deurttpu26z6">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-85" data-mp="1debk15twcyyv" />
    </noscript>;
}